import * as Ridingazua from './ridingazua.front.export';

(window as any).ridingazuaApplication = Ridingazua.Application.instance;